import React from 'react'
import Navbar from '../components/Navbar'
import MainCart from '../components/cart/MainCart'

const Cart = () => {
  return (
    <div>
      <Navbar />
      <MainCart />
    </div>
  )
}

export default Cart